var React = require('react');

function Bookmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.4 5C5.4 3.8402 6.3402 2.9 7.5 2.9H16.5C17.6598 2.9 18.6 3.8402 18.6 5V20.5482C18.6 21.0728 17.9741 21.3448 17.5906 20.9868L12.9552 16.6605C12.4174 16.1584 11.5826 16.1584 11.0448 16.6605L6.40939 20.9868C6.02586 21.3448 5.4 21.0728 5.4 20.5482V5Z","stroke":"#262F56","strokeWidth":"1.8"}));
}

Bookmark.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Bookmark;

Bookmark.default = Bookmark;
